export default __webpack_public_path__ + "static/media/orient-icon.d7b2f877.svg";